import { formatDate } from 'helpers/datesHelper.js';
const encode = encodeURIComponent;
const today = new Date();

export default (requests) => {
  return {
    getRegistrationOffers: () => {
      return requests.get('/public/offers/register/offer-codes');
    },

    manageBonus: (status, offerId) => {
      const sessionCookie = Cookies.get('X-ODDS-SESSION');
      const config = {};
      if (sessionCookie) {
        config['headers'] = { 'X-ODDS-SESSION': sessionCookie };
      }
      return requests.post(`/public/offers/bonus/${offerId}/${status}/`, {}, config);
    },

    getBonusListByFilter: ({
      activeTab = 'ACTIVE',
      endDate = today,
      startDate = today,
      limit = 5,
      currentPage = 0,
    } = {}) => {
      const offset = currentPage * limit;
      const dateFrom = formatDate(startDate, 'yyyy-MM-dd');
      const dateTo = formatDate(endDate, 'yyyy-MM-dd');
      const searchPath = []
      .concat(activeTab)
      .map((tab) => {
        return `${encode(tab.toUpperCase())}`;
      })
      .join(',');

      const sessionCookie = Cookies.get('X-ODDS-SESSION');
      const config = {};

      if (sessionCookie) {
        config['headers'] = { 'X-ODDS-SESSION': sessionCookie };
      }
      
      return requests.get(
        `/public/offers/bonus/${dateFrom}/${dateTo}/${limit + 1}/${offset}/?${searchPath}`,
        config
      );
    },

    getCreditBonusListByFilter: ({
      activeTab = 'ACTIVE',
      endDate = today,
      startDate = today,
      limit = 5,
      currentPage = 0,
    } = {}) => {
      const offset = currentPage * limit;
      const dateFrom = formatDate(startDate, 'yyyy-MM-dd');
      const dateTo = formatDate(endDate, 'yyyy-MM-dd');
      const searchPath = []
        .concat(activeTab)
        .map((tab) => {
          return `status=${encode(tab.toUpperCase())}`;
        })
        .join('&');
      
      const sessionCookie = Cookies.get('X-ODDS-SESSION');
      const config = {};
      if (sessionCookie) {
        config['headers'] = { 'X-ODDS-SESSION': sessionCookie };
      }

      return requests.get(
        `/public/offers/creditbonus/${dateFrom}/${dateTo}/${limit + 1}/${offset}/?${searchPath}`,
        config
      );
    },

    manageCreditBonus: (status, offerId) => {
      const sessionCookie = Cookies.get('X-ODDS-SESSION');
      const config = {};
      if (sessionCookie) {
        config['headers'] = { 'X-ODDS-SESSION': sessionCookie };
      }
      return requests.post(`/public/offers/creditbonus/${status}/${offerId}/`, {}, config);
    },

    getPromoCodeSetting: () => {
      return requests.get('/config/promotions');
    },
  };
};
